import type { ChipProps } from '@mui/material/Chip';

/**
 * Azure DevOps `Microsoft.VSTS.Common.Priority` is an integer 1-4 where a
 * lower number is more urgent. Single source of truth for the bug-report
 * feature — imported by the create form, the listing, and the detail view so
 * labels/colors never drift.
 */
export const BUG_PRIORITY_OPTIONS = [
  { value: 1, label: '1 - Critical' },
  { value: 2, label: '2 - High' },
  { value: 3, label: '3 - Medium' },
  { value: 4, label: '4 - Low' },
] as const;

/** Form pre-selects Medium; ADO's own default for new work items is 2. */
export const DEFAULT_BUG_PRIORITY = 3;

/** ADO's server-side default when the field is absent on a work item. */
export const ADO_DEFAULT_BUG_PRIORITY = 2;

const PRIORITY_LABELS: Record<number, string> = Object.fromEntries(
  BUG_PRIORITY_OPTIONS.map((opt) => [opt.value, opt.label]),
);

const PRIORITY_COLORS: Record<number, ChipProps['color']> = {
  1: 'error',
  2: 'warning',
  3: 'info',
  4: 'default',
};

/** Display label for a priority value, falling back to the raw number. */
export function getBugPriorityLabel(priority: number): string {
  return PRIORITY_LABELS[priority] ?? String(priority);
}

/** MUI chip color for a priority value. */
export function getBugPriorityColor(priority: number): ChipProps['color'] {
  return PRIORITY_COLORS[priority] ?? 'default';
}
